import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import useWindowDimensions from '../views/Login';
import CardContent from '@material-ui/core/CardContent';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '80vw',
    marginTop: '5vh',
    borderRadius: '10px',
    border: '1px solid #CCCCCC',
    padding: 0, "&:last-child": {
      paddingBottom: 0,
    },
    paddingBottom: 0,

  },
  father: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  father2: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  div0: {
    backgroundColor: '#ebebee',
    marginTop: '2rem',
    width: '12rem',
    height: '1.75rem',
    borderRadius: '8px',
    marginLeft: '16px'
  },
  div1: {
    backgroundColor: '#ebebee',
    marginTop: '2rem',
    width: '14rem',
    height: '2rem',
    borderRadius: '8px',
    marginLeft: '16px'
  },
  div2: {
    backgroundColor: '#ebebee',
    marginTop: '1rem',
    width: '16rem',
    height: '2rem',
    borderRadius: '8px',
    marginLeft: '16px'
  },
  div5: {
    backgroundColor: '#ebebee',
    marginTop: '1rem',
    width: '18rem',
    height: '1.75rem',
    borderRadius: '8px',
    marginLeft: '16px'
  },
  div3: {
    backgroundColor: '#ebebee',
    marginTop: '1rem',
    width: '22rem',
    height: '2rem',
    borderRadius: '8px',
    marginLeft: '16px'
  },
  div4: {
    display: 'flex',
    backgroundColor: '#ebebee',
    marginTop: '2rem',
    width: '100%',
    height: '10vh',
  },
  stepper: {
    marginTop: '5vh',
    marginLeft: '16px',
    display: 'flex',
    width: '80vw'
  },
  circulo: {
    width: '3rem',
    height: '3rem',
    borderRadius: '50%',
    backgroundColor: '#ebebee',

  },
  line: {
    width: '0.5rem',
    height: '5rem',
    marginLeft: '20px',
    backgroundColor: '#ebebee',

  },
  divStepper: {
    backgroundColor: '#ebebee',
    marginBottom: '7rem',
    width: '6rem',
    height: '1.35rem',
    borderRadius: '8px',
    marginLeft: '16px'
  },


}));


export const Loading = () => {
  const { width } = useWindowDimensions();
  const classes = useStyles();
  if (width < 780) {
    return (
      <div className={classes.father2}>
        <div className={classes.div0}></div>
        <div className={classes.div5}></div>
        <div className={classes.div5}></div>
        <div className={classes.stepper}>
          <div>
            <div className={classes.circulo}></div>
            <div className={classes.line}></div>
            <div className={classes.circulo}></div>
            <div className={classes.line}></div>
            <div className={classes.circulo}></div>
            <div className={classes.line}></div>
            <div className={classes.circulo}></div>
          </div>
          <div>
            <div className={classes.divStepper}></div>
            <div className={classes.divStepper}></div>
            <div className={classes.divStepper}></div>
            <div className={classes.divStepper}></div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className={classes.father}>
        <CardContent classes={{ root: classes.root }}>
          <div className={classes.div1}></div>
          <div className={classes.div2}></div>
          <div className={classes.div3}></div>
          <div className={classes.div4}></div>
        </CardContent>
      </div>
    );
  }

};

